export default function orgTranslateFilter($translate) {
	"ngInject";

	const filter = (type, plural) => {
		let prefix = "pros-maps.";
		if (type === "ZONE" || type === "DISTRICT" || type === "AREA") {
			prefix += "org.pros.";
		} else if (type.indexOf("WARD") === 0 || type.indexOf("STAKE") === 0) {
			prefix += "layer.";
		} else {
			prefix += "org.";
		}
		return type ? $translate.instant(prefix + type.toLowerCase() + (plural ? "s" : "")) : null;
	};
	filter.$stateful = true;
	return filter;
}
